module.exports = __webpack_public_path__ + "grootstatic/media/chevron-down.1e99c84d.svg";